import type { MessageDiscussion } from "@/types";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";

export const FlagIcons: Record<MessageDiscussion["_flag"], JSX.Element> = {
	read: <DoneAllOutlinedIcon className="!text-base !text-success-200" />,
	pending: <ScheduleOutlinedIcon className="!text-base !text-gray-200" />,
	sent: <DoneAllOutlinedIcon className="!text-base !text-success-200" />,
	delivered: <DoneAllOutlinedIcon className="!text-base !text-success-200" />,
	failed: <ErrorOutlineOutlinedIcon className="!text-base !text-danger-300" />,
};
